module.exports = __webpack_public_path__ + "img/home-not-available.30e09176.png";